import { css } from "@emotion/css";
import palette from "utility/ui/palette";

const styles = {
  smallCardIcon: css`
    color: ${palette.grey400};
  `,
  largeCardIcon: css`
    font-size: 5.4rem !important;

    transform: rotate(90deg);
  `,
};

export default styles;
